import { useEffect, useMemo, useState } from 'react';
import useMeasure from 'react-use-measure';
import Portal from "../Portal.js";
import Tooltip from "../tooltips/Tooltip.js";
import TooltipWithBounds from "../tooltips/TooltipWithBounds.js";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Hook that handles rendering of a Tooltip or TooltipWithBounds in a Portal.
 * Handles conversion of container coordinates to page coordinates using the container bounds.
 */
export default function useTooltipInPortal() {
  let {
    detectBounds: detectBoundsOption = true,
    zIndex: zIndexOption,
    ...useMeasureOptions
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const [containerRef, containerBounds, forceRefreshBounds] = useMeasure(useMeasureOptions);
  const [isSsr, setIsSsr] = useState(false);
  useEffect(() => {
    setIsSsr(false);
  }, []);
  const TooltipInPortal = useMemo(() => function (_ref) {
    let {
      left: containerLeft = 0,
      top: containerTop = 0,
      detectBounds: detectBoundsProp,
      // allow override at component-level
      zIndex: zIndexProp,
      // allow override at the component-level
      ...tooltipProps
    } = _ref;
    const detectBounds = detectBoundsProp == null ? detectBoundsOption : detectBoundsProp;
    const zIndex = zIndexProp == null ? zIndexOption : zIndexProp;
    const TooltipComponent = detectBounds ? TooltipWithBounds : Tooltip;
    // convert container coordinates to page coordinates
    const scrollX = isSsr ? 0 : window.scrollX;
    const scrollY = isSsr ? 0 : window.scrollY;
    const portalLeft = containerLeft + (containerBounds.left || 0) + scrollX;
    const portalTop = containerTop + (containerBounds.top || 0) + scrollY;
    return /*#__PURE__*/_jsx(Portal, {
      zIndex: zIndex,
      children: /*#__PURE__*/_jsx(TooltipComponent, {
        left: portalLeft,
        top: portalTop,
        ...tooltipProps
      })
    });
  }, [detectBoundsOption, zIndexOption, containerBounds.left, containerBounds.top, isSsr]);
  return {
    containerRef,
    containerBounds,
    forceRefreshBounds,
    TooltipInPortal
  };
}